import React from 'react';

interface CurvedDividerProps {
  color?: string;
  top?: boolean;
  className?: string;
  invert?: boolean;
}

export function CurvedDivider({
  color = 'white',
  top = false,
  className = '',
  invert = false,
}: CurvedDividerProps) {
  const positionClass = top ? '-top-[1px] z-10' : '-bottom-[1px] z-10';

  // Combine both transformations if needed
  let transform = '';
  if (top) transform += 'scale(1, -1) ';
  if (invert) transform += 'scale(1, -1)';

  // If both top and invert are true, they cancel each other out
  if (top && invert) transform = '';

  return (
    <div
      className={`curved-div absolute left-0 w-full overflow-hidden ${positionClass} ${className}`}
    >
      <svg
        viewBox="0 0 1200 20"
        preserveAspectRatio="none"
        className={`block h-3 w-full sm:h-8`}
        style={{ transform }}
        aria-hidden="true"
      >
        <path d="M0,0 Q600,40 1200,0 L1200,20 L0,20 Z" fill={color} />
      </svg>
    </div>
  );
}
